<sk-scrollable-container class="application-list-scroll"
                         [floatingScrollbar]="true">
  <mat-nav-list class="application-menu-list">
    @for (application of applications(); track application.id) {
      <a mat-list-item
         [attr.data-test]="'application-' + application.applicationAlias"
         class="application-menu-list__item"
         (click)="saveSelectedApp(application.applicationAlias)"
         [routerLink]="getApplicationLink(application.applicationAlias)"
         queryParamsHandling="preserve"
         [activated]="currentAppAlias() === application.applicationAlias"
         data-test="application-switcher-link">
        @if ('iris' !== application.applicationAlias) {
          <i class="fa-fw icon" [class]="application.logo"></i>
        } @else if (brandData()) {
          <img
            [src]="('data:image/png;base64,' + brandData()) | safeUrl"
            [alt]="brandName() + ' logo'">
        }
        <span>{{ application.nameTranslated ?? application.name }}</span>
      </a>
    }
  </mat-nav-list>
</sk-scrollable-container>
